import { Icon } from '@chakra-ui/react'

type Props = {
    width: number
    height: number
}

export const PasswordEyeIcon = ({ width, height }: Props): JSX.Element => {
    return (
        <Icon viewBox={`0 0 ${width * 4} ${height * 4} `} w={width} h={height}>
            <path
                d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 7.69253 5.04625 7.39587 5.13218 7.11659C5.36736 7.63749 5.89135 8 6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.89135 7.63749 5.36736 7.11659 5.13218C7.39587 5.04625 7.69253 5 8 5C9.65685 5 11 6.34315 11 8Z"
                fill="#828282"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 8C16 9 12.4183 13 8 13C3.58172 13 0 9 0 8C0 7 3.58172 3 8 3C12.4183 3 16 7 16 8ZM12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8Z"
                fill="#828282"
            />
        </Icon>
    )
}
